<template>
    <v-card class="elavation-1" :style="isMobile?'margin-bottom:-3px':'margin-bottom:20px'"> 
        <v-toolbar flat height="40px" @click="commentsVisible=!commentsVisible" title="Comments" style="cursor:pointer;">
            <v-icon>forum</v-icon>
            <b style="margin-left:10px;">COMMENTS</b>
            <v-spacer></v-spacer>
            <v-btn v-if="commentsVisible" icon title="Minimize">
                <v-icon>minimize</v-icon>
            </v-btn>
            <v-btn v-if="!commentsVisible" icon title="Minimize">
                <v-icon>expand_more</v-icon>
            </v-btn>
        </v-toolbar>
        <p v-if="error" style="color:red;">{{errorMessage}}</p>
        <div v-if="commentsVisible">
            <v-card-text>
                <v-layout row wrap>
                    <v-flex xs1>
                        <v-list-tile-avatar size="30" class="text-xs-center">
                            <v-img ref="avatar" :src="myAvatar"></v-img> 
                        </v-list-tile-avatar>                    
                    </v-flex>
                    <v-flex xs11 class="text-xs-left" style="margin-top:-5px;">
                        <v-text-field color="primary"
                            v-model="message"
                            append-icon="send"
                            clear-icon="clear"
                            box clearable
                            label="Add comment"
                            type="text"
                            max="1000"
                            :style="isMobile?'margin-left:10px':''"
                            @click:append="postComment"
                            @keypress="keypressHandler"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-data-table
                :headers="headers"
                :items="messages.slice()"
                :loading="loading"
                hide-headers
                :hide-actions="messages.length<6"
                style="margin-top:-30px;"
            >
                <template v-slot:no-data>
                    <div class="caption text-xs-center">No messages found</div>
                </template>
                <template v-slot:items="props">
                    <tr>
                        <td>
                            <div style="margin:10px 0px -10px -8px;">
                                <v-layout row wrap>
                                    <v-flex xs1>
                                        <v-list-tile-avatar size="30" class="text-xs-center">
                                            <img :src="`${props.item.avatar}`">
                                        </v-list-tile-avatar>                            
                                    </v-flex>
                                    <v-flex xs11 class="text-xs-left">
                                        <span class="caption" :style="isMobile?'margin-left:8px':''"><b>{{props.item.sender}}</b>, <span :title="props.item.postDateFullFmt">{{props.item.postDate}}</span></span>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs1></v-flex>
                                    <v-flex xs11 class="text-xs-left" style="margin:-15px 0px 15px 0px;">
                                        <div class="text-xs-left" :style="isMobile?'margin-left:10px':''" v-html="props.item.message"></div>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </td>
                    </tr>
                </template>
            </v-data-table> 
        </div>
    </v-card>
</template>
<script>

import commentsHistoryApi from '@/api/commentshistory'
import notificationsApi from '@/api/notifications'
import Vue from 'vue'
import dateFormat from '@/common/date_format'

const signalR = require('@microsoft/signalr'); 
Vue.prototype.$signalR = signalR;

export default {
    components: {},
    data() {
        return {
            error: false,
            errorMessage: null,
            signalRConnection: null,    
            message: null,
            messages: [],
            headers: [
                {text: 'Message',align: 'left',value: '', width: '100%', sortable:false}
             ],
            loading: false,
            commentsVisible: true
        }
    },
    props: ['comments_data'],
    methods: {
        keypressHandler(event) {
            if (event.code=='Enter') this.postComment()
        },
        async initializeSignalR() {
            await this.signalRConnection.start().catch(err => console.error(err));
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_COMMENTSHISTORY_INVOKE, this.comments_data.pageQueryId);
            
            this.signalRConnection.on(process.env.VUE_APP_HUB_COMMENTSHISTORY_ALERT, data => {
                this.commentsVisible = true
                this.messages.unshift(
                    {
                        message: data.message,
                        sender: data.sender,  
                        avatar: data.avatar,
                        postDateFullFmt: this.$moment(data.createdOn).format('MMM DD, YYYY hh:mma'),
                        postDate: dateFormat.formatDate(data.postDate)
                    }
                )
            });
        },
        async invokeSubscribe() {
            await this.signalRConnection.invoke(process.env.VUE_APP_HUB_COMMENTSHISTORY_INVOKE, this.comments_data.pageQueryId);
        },
        postComment() {
            if (this.message != null) {
                var data = {
                    message: this.message,
                    createdBy: this.$store.state.userId,    //logged-in userid
                    pageQueryId: this.comments_data.pageQueryId
                }
                this.signalRConnection.invoke('postComment', data).catch(err => console.error(err));
                this.sendCommentsNotification()
            }
        },
        async sendCommentsNotification() {
            try {
                const message = this.message
                this.message = null
                var data = {
                    pageQueryId: this.comments_data.pageQueryId,
                    comment: message,
                    createdBy: this.$store.state.userId,
                    pageItemCreatedBy: this.comments_data.pageItemCreatedBy,
                    pageLink: this.comments_data.pageLink,
                    pageKey: this.comments_data.pageKey,    
                    notificationTypeId: this.comments_data.notificationTypeId
                }
                await notificationsApi.sendCommentsNotification(data)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async getCommentsHistory() {
            try {
                this.loading = true
                this.messages = []
                const response = await commentsHistoryApi.getAll(this.comments_data.pageQueryId)
                if (response.status == 200) {
                    response.data.items.forEach(item => {
                        this.messages.push(
                            {
                                message: item.comment,
                                sender: item.sender,  
                                avatar: item.avatar,
                                postDateFullFmt: this.$moment(item.createdOn).format('MMM DD, YYYY hh:mma'),
                                postDate: dateFormat.formatDate(item.createdOn)
                            }
                        )
                    })
                }

                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        this.getCommentsHistory()

        //signalR
        this.signalRConnection = new this.$signalR.HubConnectionBuilder()
                          .withUrl(`${process.env.VUE_APP_HUB_URL}commentshistory`) 
                          .configureLogging(this.$signalR.LogLevel.Information)
                          .withAutomaticReconnect()
                          .build()
    },
    async mounted() { 
        await this.initializeSignalR()
    },
    computed: {
        myAvatar() {
            return this.$store.state.avatar
        },
        isMobile() {
            return window.innerWidth < 600
        },
    },
    destroyed() {
        this.signalRConnection = null
    },
}
</script>
